<template>
  <div class="paypal">
    <Header />
    <div class="paypal-main">
      <RewardsChild
        :rewardsChildData="rewardsChildData"
        @exchange="exchange"
      ></RewardsChild>
    </div>
    <Footer />

    <el-dialog
      title="Tips"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="dialog-line">
       कृपया अपना पेईपाल खाता और पूरा नाम को पुष्टि करें
      </div>
      <div class="dialog-line">paypal:{{ paypal }}</div>
      <div class="dialog-line">पूरा नाम:{{ name }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">रद्द करें </el-button>
        <el-button type="primary" @click="handle">पुष्टि करें </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Tips"
      :visible.sync="dialogVisible2"
      :before-close="handleClose2"
    >
      <div class="dialog-line">
        कृपया अपने PayPal खाते और पूरा नाम को पूरा करें।
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handle2">पुष्टि करें </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import RewardsChild from "./mycom/rewardsChild.vue";
import { paypal } from "@/utlis/storageData.js";
import { handleOrder, users } from "@/api/api.js";
import { Notify } from "vant";
import { Toast } from "vant";
export default {
  components: { Header, Footer, RewardsChild },
  data() {
    return {
      rewardsChildData: paypal,
      dialogVisible: false,
      dialogVisible2: false,
      paypal: "",
      name: "",
    };
  },
  methods: {
    async getName() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      await users(params).then((res) => {
        //console.log(res);
        if (res.code === 200) {
          console.log("res", res.data);
          this.name = res.data.name;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
    async exchange() {
      //获取accountInfo
      this.paypal = JSON.parse(localStorage.getItem("accountInfo")).paypal;
      await this.getName();
      if (!this.paypal || !this.name) {
        this.dialogVisible2 = true;
      } else {
        this.dialogVisible = true;
      }
      console.log(this.paypal, this.name);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    // 立即兑换
    handle() {
      const params = {
        giftId: this.$route.query.id,
      };
      this.dialogVisible = false;
      handleOrder(params).then((res) => {
        if (res.code === 200) {
          Notify({ type: "primary", message: res.errors[0] });
          this.$router.push("/orderHistory");
        } else {
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },
    //前往
    handle2() {
      this.$router.push("/settingsPaypal");
    },
  },
  created() {
    this.rewardsChildData.number = this.$route.query.number;
  },
};
</script>
<style scoped>
.paypal {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.paypal-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}

.paypal >>> .el-dialog__header > span {
  font-size: 15px !important;
}
.paypal >>> .el-dialog__body {
  padding-top: 5px;
  padding-bottom: 5px;
}
.paypal >>> .el-dialog {
  width: 375px;
}
.dialog-footer > .el-button {
  font-size: 11px;
  padding: 8px 16px;
}
.dialog-line {
  margin: 10px 0;
  font-size: 10px;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1280px) {
  .paypal-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1080px) {
  .paypal-main {
    width: calc(100% - 45px);
    padding: 20px 27.5px;
  }
}
@media only screen and (max-width: 1000px) {
  .paypal-main {
    width: calc(100% - 40px);
    padding: 20px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/paypal.vue